import { Component } from '@angular/core';

@Component({
  selector: 'md-card',
  template: require('./card.component.html'),
  styles: [require('./card.component.scss')]
})

export class CardComponent {

}
